(() => {
  const $burger = $("[data-menu-mobile=burger]")
  const $nav = $("[data-menu-mobile=nav]")
  const $list_item = $("[data-menu-mobile=item]")
  const $close = $("[data-menu-mobile=close]")

  const openMenu = () => {
    $nav.addClass("_is-active")
    document.querySelector("body").style.overflowY = "hidden"
  }

  const closeMenu = () => {
    $nav.removeClass("_is-active")
    document.querySelector("body").style.overflowY = "scroll"
  }

  $burger.on("click", openMenu)

  $close.on("click", closeMenu)

  $list_item.on("click", closeMenu)

  /** fixed menu */
  const menu = $("[data-menu-scroll=fixed]")

  if (menu) {
    const scrollTop = () => {
      window.addEventListener("scroll", () => {
        const position = document.documentElement.scrollTop || document.body.scrollTop
        const isFixed = menu.hasClass("fixed")
        const startFixed = 0
        if (position > startFixed && !isFixed) {
          menu.addClass("fixed")
        } else if (position < startFixed) {
          menu.removeClass("fixed")
        }
      })
    }
    window.addEventListener("resize", scrollTop)
    window.addEventListener("scroll", scrollTop)
    // 		window.dispatchEvent(new CustomEvent('scroll'))
    $(window).trigger("scroll")
  }

  const toggle = $(".menu-nav-mobile__item.dropdown-menu")

  toggle.click((e) => {
    const item = $(e.currentTarget).closest("[data-dropdown=item]")

    item.toggleClass("active")
  })
})()
;(() => {
  const SCROLL_VALUE = 445
  const menus = document.querySelectorAll(".menu-nav__item.dropdown-menu")

  Array.from(menus).forEach((menu) => {
    const removeStyle = () => {
      menu.classList.remove("active")
    }

    const addStyle = () => {
      menu.classList.add("active")
    }

    window.addEventListener("scroll", () => {
      if (pageYOffset > SCROLL_VALUE && menu.classList.contains("active")) {
        $(menu.querySelector(".dropdown-menu__content")).slideUp("slow")

        setTimeout(removeStyle, 400)
      }
    })

    menu.addEventListener("click", () => {
      Array.from(menus).forEach((m) => {
        $(m.querySelector(".dropdown-menu__content")).slideUp("slow")
        setTimeout(() => m.classList.remove("active"), 400)
      })

      if (menu.classList.contains("active")) {
        $(menu.querySelector(".dropdown-menu__content")).slideUp("slow")
        setTimeout(removeStyle, 400)
      } else {
        $(menu.querySelector(".dropdown-menu__content")).slideDown("slow")

        setTimeout(addStyle, 400)
      }
    })
  })
})()



// WEBPACK FOOTER //
// ./src/blocks/menu/menu-mobile.js